import { Space } from 'antd';
import React, {
  CSSProperties, useContext,
} from 'react';

import { LayoutContext } from '../../common/components/Mainlayout/context';

import mapModifiers from 'common/utils/functions';

import './index.scss';

interface HeaderKioskProps {
  fixed?: boolean;
  title: string;
  rightHeader?: React.ReactNode;
  icon?: React.ReactNode;
  bgColor?: 'purple' | 'blue' | string
}

interface CustomCSS extends CSSProperties {
  '--sidebar-width': string;
}

const HeaderKiosk: React.FC<HeaderKioskProps> = ({
  fixed,
  title,
  rightHeader,
  icon,
  bgColor = 'purple'
}) => {
  const { collapsed } = useContext(LayoutContext);

  return (
    <div
      className={mapModifiers('t-headerKiosk', fixed && 'fixed', bgColor)}
      style={{
        '--sidebar-width': collapsed ? '80px' : '300px',
      } as CustomCSS}
    >
      <header className="t-headerKiosk_wrapper">
        <div className="t-headerKiosk_content">
          <div className="t-headerKiosk_leftHeader">
            <div className="t-headerKiosk_icon">
              {icon}
            </div>
            <h3 className="t-headerKiosk_title">
              {title}
            </h3>
          </div>
          <div className="t-headerKiosk_rightHeader">
            <Space>
              {rightHeader}
            </Space>
          </div>
        </div>
      </header>
    </div>
  );
};

export default HeaderKiosk;
